import { createProxyIdentifier } from '../../services/extensions/common/proxyIdentifier.js';
var TextEditorRevealType;
( (function(TextEditorRevealType) {
    TextEditorRevealType[TextEditorRevealType["Default"] = 0] = "Default";
    TextEditorRevealType[TextEditorRevealType["InCenter"] = 1] = "InCenter";
    TextEditorRevealType[TextEditorRevealType["InCenterIfOutsideViewport"] = 2] = "InCenterIfOutsideViewport";
    TextEditorRevealType[TextEditorRevealType["AtTop"] = 3] = "AtTop";
})(TextEditorRevealType || (TextEditorRevealType = {})));
var TabInputKind;
( (function(TabInputKind) {
    TabInputKind[TabInputKind["UnknownInput"] = 0] = "UnknownInput";
    TabInputKind[TabInputKind["TextInput"] = 1] = "TextInput";
    TabInputKind[TabInputKind["TextDiffInput"] = 2] = "TextDiffInput";
    TabInputKind[TabInputKind["TextMergeInput"] = 3] = "TextMergeInput";
    TabInputKind[TabInputKind["NotebookInput"] = 4] = "NotebookInput";
    TabInputKind[TabInputKind["NotebookDiffInput"] = 5] = "NotebookDiffInput";
    TabInputKind[TabInputKind["CustomEditorInput"] = 6] = "CustomEditorInput";
    TabInputKind[TabInputKind["WebviewEditorInput"] = 7] = "WebviewEditorInput";
    TabInputKind[TabInputKind["TerminalEditorInput"] = 8] = "TerminalEditorInput";
    TabInputKind[TabInputKind["InteractiveEditorInput"] = 9] = "InteractiveEditorInput";
    TabInputKind[TabInputKind["ChatEditorInput"] = 10] = "ChatEditorInput";
    TabInputKind[TabInputKind["MultiDiffEditorInput"] = 11] = "MultiDiffEditorInput";
})(TabInputKind || (TabInputKind = {})));
var TabModelOperationKind;
( (function(TabModelOperationKind) {
    TabModelOperationKind[TabModelOperationKind["TAB_OPEN"] = 0] = "TAB_OPEN";
    TabModelOperationKind[TabModelOperationKind["TAB_CLOSE"] = 1] = "TAB_CLOSE";
    TabModelOperationKind[TabModelOperationKind["TAB_UPDATE"] = 2] = "TAB_UPDATE";
    TabModelOperationKind[TabModelOperationKind["TAB_MOVE"] = 3] = "TAB_MOVE";
})(TabModelOperationKind || (TabModelOperationKind = {})));
var WebviewMessageArrayBufferViewType;
( (function(WebviewMessageArrayBufferViewType) {
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Int8Array"] = 1] = "Int8Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Uint8Array"] = 2] = "Uint8Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Uint8ClampedArray"] = 3] = "Uint8ClampedArray";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Int16Array"] = 4] = "Int16Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Uint16Array"] = 5] = "Uint16Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Int32Array"] = 6] = "Int32Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Uint32Array"] = 7] = "Uint32Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Float32Array"] = 8] = "Float32Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["Float64Array"] = 9] = "Float64Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["BigInt64Array"] = 10] = "BigInt64Array";
    WebviewMessageArrayBufferViewType[WebviewMessageArrayBufferViewType["BigUint64Array"] = 11] = "BigUint64Array";
})(
    WebviewMessageArrayBufferViewType || (WebviewMessageArrayBufferViewType = {})
));
var NotebookEditorRevealType;
( (function(NotebookEditorRevealType) {
    NotebookEditorRevealType[NotebookEditorRevealType["Default"] = 0] = "Default";
    NotebookEditorRevealType[NotebookEditorRevealType["InCenter"] = 1] = "InCenter";
    NotebookEditorRevealType[NotebookEditorRevealType["InCenterIfOutsideViewport"] = 2] = "InCenterIfOutsideViewport";
    NotebookEditorRevealType[NotebookEditorRevealType["AtTop"] = 3] = "AtTop";
})(NotebookEditorRevealType || (NotebookEditorRevealType = {})));
var CandidatePortSource;
( (function(CandidatePortSource) {
    CandidatePortSource[CandidatePortSource["None"] = 0] = "None";
    CandidatePortSource[CandidatePortSource["Process"] = 1] = "Process";
    CandidatePortSource[CandidatePortSource["Output"] = 2] = "Output";
    CandidatePortSource[CandidatePortSource["Hybrid"] = 3] = "Hybrid";
})(CandidatePortSource || (CandidatePortSource = {})));
var ISuggestDataDtoField;
( (function(ISuggestDataDtoField) {
    ISuggestDataDtoField["label"] = "a";
    ISuggestDataDtoField["kind"] = "b";
    ISuggestDataDtoField["detail"] = "c";
    ISuggestDataDtoField["documentation"] = "d";
    ISuggestDataDtoField["sortText"] = "e";
    ISuggestDataDtoField["filterText"] = "f";
    ISuggestDataDtoField["preselect"] = "g";
    ISuggestDataDtoField["insertText"] = "h";
    ISuggestDataDtoField["insertTextRules"] = "i";
    ISuggestDataDtoField["range"] = "j";
    ISuggestDataDtoField["commitCharacters"] = "k";
    ISuggestDataDtoField["additionalTextEdits"] = "l";
    ISuggestDataDtoField["kindModifier"] = "m";
    ISuggestDataDtoField["commandIdent"] = "n";
    ISuggestDataDtoField["commandId"] = "o";
    ISuggestDataDtoField["commandArguments"] = "p";
})(ISuggestDataDtoField || (ISuggestDataDtoField = {})));
var ISuggestResultDtoField;
( (function(ISuggestResultDtoField) {
    ISuggestResultDtoField["defaultRanges"] = "a";
    ISuggestResultDtoField["completions"] = "b";
    ISuggestResultDtoField["isIncomplete"] = "c";
    ISuggestResultDtoField["duration"] = "d";
})(ISuggestResultDtoField || (ISuggestResultDtoField = {})));
const MainContext = {
    MainThreadAuthentication: ( createProxyIdentifier('MainThreadAuthentication')),
    MainThreadBulkEdits: ( createProxyIdentifier('MainThreadBulkEdits')),
    MainThreadLanguageModels: ( createProxyIdentifier('MainThreadLanguageModels')),
    MainThreadEmbeddings: ( createProxyIdentifier('MainThreadEmbeddings')),
    MainThreadChatAgents2: ( createProxyIdentifier('MainThreadChatAgents2')),
    MainThreadChatVariables: ( createProxyIdentifier('MainThreadChatVariables')),
    MainThreadLanguageModelTools: ( createProxyIdentifier('MainThreadChatSkills')),
    MainThreadClipboard: ( createProxyIdentifier('MainThreadClipboard')),
    MainThreadCommands: ( createProxyIdentifier('MainThreadCommands')),
    MainThreadComments: ( createProxyIdentifier('MainThreadComments')),
    MainThreadConfiguration: ( createProxyIdentifier('MainThreadConfiguration')),
    MainThreadConsole: ( createProxyIdentifier('MainThreadConsole')),
    MainThreadDebugService: ( createProxyIdentifier('MainThreadDebugService')),
    MainThreadDecorations: ( createProxyIdentifier('MainThreadDecorations')),
    MainThreadDiagnostics: ( createProxyIdentifier('MainThreadDiagnostics')),
    MainThreadDialogs: ( createProxyIdentifier('MainThreadDiaglogs')),
    MainThreadDocuments: ( createProxyIdentifier('MainThreadDocuments')),
    MainThreadDocumentContentProviders: ( createProxyIdentifier('MainThreadDocumentContentProviders')),
    MainThreadTextEditors: ( createProxyIdentifier('MainThreadTextEditors')),
    MainThreadEditorInsets: ( createProxyIdentifier('MainThreadEditorInsets')),
    MainThreadEditorTabs: ( createProxyIdentifier('MainThreadEditorTabs')),
    MainThreadErrors: ( createProxyIdentifier('MainThreadErrors')),
    MainThreadTreeViews: ( createProxyIdentifier('MainThreadTreeViews')),
    MainThreadDownloadService: ( createProxyIdentifier('MainThreadDownloadService')),
    MainThreadLanguageFeatures: ( createProxyIdentifier('MainThreadLanguageFeatures')),
    MainThreadLanguages: ( createProxyIdentifier('MainThreadLanguages')),
    MainThreadLogger: ( createProxyIdentifier('MainThreadLogger')),
    MainThreadMessageService: ( createProxyIdentifier('MainThreadMessageService')),
    MainThreadOutputService: ( createProxyIdentifier('MainThreadOutputService')),
    MainThreadProgress: ( createProxyIdentifier('MainThreadProgress')),
    MainThreadQuickDiff: ( createProxyIdentifier('MainThreadQuickDiff')),
    MainThreadQuickOpen: ( createProxyIdentifier('MainThreadQuickOpen')),
    MainThreadStatusBar: ( createProxyIdentifier('MainThreadStatusBar')),
    MainThreadSecretState: ( createProxyIdentifier('MainThreadSecretState')),
    MainThreadStorage: ( createProxyIdentifier('MainThreadStorage')),
    MainThreadSpeech: ( createProxyIdentifier('MainThreadSpeechProvider')),
    MainThreadTelemetry: ( createProxyIdentifier('MainThreadTelemetry')),
    MainThreadTerminalService: ( createProxyIdentifier('MainThreadTerminalService')),
    MainThreadTerminalShellIntegration: ( createProxyIdentifier('MainThreadTerminalShellIntegration')),
    MainThreadWebviews: ( createProxyIdentifier('MainThreadWebviews')),
    MainThreadWebviewPanels: ( createProxyIdentifier('MainThreadWebviewPanels')),
    MainThreadWebviewViews: ( createProxyIdentifier('MainThreadWebviewViews')),
    MainThreadCustomEditors: ( createProxyIdentifier('MainThreadCustomEditors')),
    MainThreadUrls: ( createProxyIdentifier('MainThreadUrls')),
    MainThreadUriOpeners: ( createProxyIdentifier('MainThreadUriOpeners')),
    MainThreadProfileContentHandlers: ( createProxyIdentifier('MainThreadProfileContentHandlers')),
    MainThreadWorkspace: ( createProxyIdentifier('MainThreadWorkspace')),
    MainThreadFileSystem: ( createProxyIdentifier('MainThreadFileSystem')),
    MainThreadFileSystemEventService: ( createProxyIdentifier('MainThreadFileSystemEventService')),
    MainThreadExtensionService: ( createProxyIdentifier('MainThreadExtensionService')),
    MainThreadSCM: ( createProxyIdentifier('MainThreadSCM')),
    MainThreadSearch: ( createProxyIdentifier('MainThreadSearch')),
    MainThreadShare: ( createProxyIdentifier('MainThreadShare')),
    MainThreadTask: ( createProxyIdentifier('MainThreadTask')),
    MainThreadWindow: ( createProxyIdentifier('MainThreadWindow')),
    MainThreadLabelService: ( createProxyIdentifier('MainThreadLabelService')),
    MainThreadNotebook: ( createProxyIdentifier('MainThreadNotebook')),
    MainThreadNotebookDocuments: ( createProxyIdentifier('MainThreadNotebookDocumentsShape')),
    MainThreadNotebookEditors: ( createProxyIdentifier('MainThreadNotebookEditorsShape')),
    MainThreadNotebookKernels: ( createProxyIdentifier('MainThreadNotebookKernels')),
    MainThreadNotebookRenderers: ( createProxyIdentifier('MainThreadNotebookRenderers')),
    MainThreadInteractive: ( createProxyIdentifier('MainThreadInteractive')),
    MainThreadTheming: ( createProxyIdentifier('MainThreadTheming')),
    MainThreadTunnelService: ( createProxyIdentifier('MainThreadTunnelService')),
    MainThreadManagedSockets: ( createProxyIdentifier('MainThreadManagedSockets')),
    MainThreadTimeline: ( createProxyIdentifier('MainThreadTimeline')),
    MainThreadTesting: ( createProxyIdentifier('MainThreadTesting')),
    MainThreadLocalization: ( createProxyIdentifier('MainThreadLocalizationShape')),
    MainThreadAiRelatedInformation: ( createProxyIdentifier('MainThreadAiRelatedInformation')),
    MainThreadAiEmbeddingVector: ( createProxyIdentifier('MainThreadAiEmbeddingVector'))
};
const ExtHostContext = {
    ExtHostCommands: ( createProxyIdentifier('ExtHostCommands')),
    ExtHostConfiguration: ( createProxyIdentifier('ExtHostConfiguration')),
    ExtHostDiagnostics: ( createProxyIdentifier('ExtHostDiagnostics')),
    ExtHostDebugService: ( createProxyIdentifier('ExtHostDebugService')),
    ExtHostDecorations: ( createProxyIdentifier('ExtHostDecorations')),
    ExtHostDocumentsAndEditors: ( createProxyIdentifier('ExtHostDocumentsAndEditors')),
    ExtHostDocuments: ( createProxyIdentifier('ExtHostDocuments')),
    ExtHostDocumentContentProviders: ( createProxyIdentifier('ExtHostDocumentContentProviders')),
    ExtHostDocumentSaveParticipant: ( createProxyIdentifier('ExtHostDocumentSaveParticipant')),
    ExtHostEditors: ( createProxyIdentifier('ExtHostEditors')),
    ExtHostTreeViews: ( createProxyIdentifier('ExtHostTreeViews')),
    ExtHostFileSystem: ( createProxyIdentifier('ExtHostFileSystem')),
    ExtHostFileSystemInfo: ( createProxyIdentifier('ExtHostFileSystemInfo')),
    ExtHostFileSystemEventService: ( createProxyIdentifier('ExtHostFileSystemEventService')),
    ExtHostLanguages: ( createProxyIdentifier('ExtHostLanguages')),
    ExtHostLanguageFeatures: ( createProxyIdentifier('ExtHostLanguageFeatures')),
    ExtHostQuickOpen: ( createProxyIdentifier('ExtHostQuickOpen')),
    ExtHostQuickDiff: ( createProxyIdentifier('ExtHostQuickDiff')),
    ExtHostStatusBar: ( createProxyIdentifier('ExtHostStatusBar')),
    ExtHostShare: ( createProxyIdentifier('ExtHostShare')),
    ExtHostExtensionService: ( createProxyIdentifier('ExtHostExtensionService')),
    ExtHostLogLevelServiceShape: ( createProxyIdentifier('ExtHostLogLevelServiceShape')),
    ExtHostTerminalService: ( createProxyIdentifier('ExtHostTerminalService')),
    ExtHostTerminalShellIntegration: ( createProxyIdentifier('ExtHostTerminalShellIntegration')),
    ExtHostSCM: ( createProxyIdentifier('ExtHostSCM')),
    ExtHostSearch: ( createProxyIdentifier('ExtHostSearch')),
    ExtHostTask: ( createProxyIdentifier('ExtHostTask')),
    ExtHostWorkspace: ( createProxyIdentifier('ExtHostWorkspace')),
    ExtHostWindow: ( createProxyIdentifier('ExtHostWindow')),
    ExtHostWebviews: ( createProxyIdentifier('ExtHostWebviews')),
    ExtHostWebviewPanels: ( createProxyIdentifier('ExtHostWebviewPanels')),
    ExtHostCustomEditors: ( createProxyIdentifier('ExtHostCustomEditors')),
    ExtHostWebviewViews: ( createProxyIdentifier('ExtHostWebviewViews')),
    ExtHostEditorInsets: ( createProxyIdentifier('ExtHostEditorInsets')),
    ExtHostEditorTabs: ( createProxyIdentifier('ExtHostEditorTabs')),
    ExtHostProgress: ( createProxyIdentifier('ExtHostProgress')),
    ExtHostComments: ( createProxyIdentifier('ExtHostComments')),
    ExtHostSecretState: ( createProxyIdentifier('ExtHostSecretState')),
    ExtHostStorage: ( createProxyIdentifier('ExtHostStorage')),
    ExtHostUrls: ( createProxyIdentifier('ExtHostUrls')),
    ExtHostUriOpeners: ( createProxyIdentifier('ExtHostUriOpeners')),
    ExtHostProfileContentHandlers: ( createProxyIdentifier('ExtHostProfileContentHandlers')),
    ExtHostOutputService: ( createProxyIdentifier('ExtHostOutputService')),
    ExtHostLabelService: ( createProxyIdentifier('ExtHostLabelService')),
    ExtHostNotebook: ( createProxyIdentifier('ExtHostNotebook')),
    ExtHostNotebookDocuments: ( createProxyIdentifier('ExtHostNotebookDocuments')),
    ExtHostNotebookEditors: ( createProxyIdentifier('ExtHostNotebookEditors')),
    ExtHostNotebookKernels: ( createProxyIdentifier('ExtHostNotebookKernels')),
    ExtHostNotebookRenderers: ( createProxyIdentifier('ExtHostNotebookRenderers')),
    ExtHostNotebookDocumentSaveParticipant: ( createProxyIdentifier('ExtHostNotebookDocumentSaveParticipant')),
    ExtHostInteractive: ( createProxyIdentifier('ExtHostInteractive')),
    ExtHostChatAgents2: ( createProxyIdentifier('ExtHostChatAgents')),
    ExtHostChatVariables: ( createProxyIdentifier('ExtHostChatVariables')),
    ExtHostLanguageModelTools: ( createProxyIdentifier('ExtHostChatSkills')),
    ExtHostChatProvider: ( createProxyIdentifier('ExtHostChatProvider')),
    ExtHostSpeech: ( createProxyIdentifier('ExtHostSpeech')),
    ExtHostEmbeddings: ( createProxyIdentifier('ExtHostEmbeddings')),
    ExtHostAiRelatedInformation: ( createProxyIdentifier('ExtHostAiRelatedInformation')),
    ExtHostAiEmbeddingVector: ( createProxyIdentifier('ExtHostAiEmbeddingVector')),
    ExtHostTheming: ( createProxyIdentifier('ExtHostTheming')),
    ExtHostTunnelService: ( createProxyIdentifier('ExtHostTunnelService')),
    ExtHostManagedSockets: ( createProxyIdentifier('ExtHostManagedSockets')),
    ExtHostAuthentication: ( createProxyIdentifier('ExtHostAuthentication')),
    ExtHostTimeline: ( createProxyIdentifier('ExtHostTimeline')),
    ExtHostTesting: ( createProxyIdentifier('ExtHostTesting')),
    ExtHostTelemetry: ( createProxyIdentifier('ExtHostTelemetry')),
    ExtHostLocalization: ( createProxyIdentifier('ExtHostLocalization'))
};
export { CandidatePortSource, ExtHostContext, ISuggestDataDtoField, ISuggestResultDtoField, MainContext, NotebookEditorRevealType, TabInputKind, TabModelOperationKind, TextEditorRevealType, WebviewMessageArrayBufferViewType };
